import moment from 'moment'
import toast from 'react-hot-toast'

/**
 * Validates whether the date range exceeds 1 calendar month.
 * If it exceeds, triggers an error toast and returns false.
 * Otherwise returns true.
 *
 * @param {Date|string} startDate
 * @param {Date|string} endDate
 * @param {Function} [t] - Translation function (optional)
 * @returns {boolean}
 */
export const validateOneMonthRange = (startDate, endDate, t) => {
  if (
    startDate &&
    endDate &&
    moment(startDate).isValid() &&
    moment(endDate).isValid() &&
    moment(endDate).isAfter(moment(startDate).add(1, 'month'), 'day')
  ) {
    toast.error(t ? t('Date range cannot exceed 1 month') : 'Date range cannot exceed 1 month')
    return false
  }
  return true
}

/**
 * Returns minimum allowed end date (same as start date).
 *
 * @param {Date|string} startDate
 * @returns {Date|null}
 */
export const getMinDate = startDate => {
  return startDate && moment(startDate).isValid()
    ? moment(startDate).toDate()
    : null
}

/**
 * Returns maximum allowed end date (1 calendar month after start date).
 *
 * @param {Date|string} startDate
 * @returns {Date|null}
 */
export const getOneMonthMaxDate = startDate => {
  return startDate && moment(startDate).isValid()
    ? moment(startDate).add(1, 'month').toDate()
    : null
}
